import { Box, Typography, Tooltip } from '@mui/material';
import {
  getMaintenanceStatusLabel,
  getLiftTypeLabel,
  type Lift,
} from '@/hooks';

interface LiftMarkerProps {
  lift: Lift;
  x: number;
  y: number;
  isDragging: boolean;
  onMouseDown: () => void;
  onTouchStart: () => void;
}

// Maintenance-status colors map to semantic MUI palette tokens (sx string form).
const statusBgColors: Record<string, string> = {
  operational: 'success.main',
  needs_maintenance: 'warning.main',
  out_of_service: 'error.main',
};

export function LiftMarker({
  lift,
  x,
  y,
  isDragging,
  onMouseDown,
  onTouchStart,
}: LiftMarkerProps) {
  const bgColor = statusBgColors[lift.maintenanceStatus] ?? 'success.main';

  return (
    <Tooltip
      title={`${lift.name} (${getLiftTypeLabel(lift.type)}) — ${getMaintenanceStatusLabel(lift.maintenanceStatus)}`}
      placement="top"
      disableInteractive
    >
      <Box
        onMouseDown={(e) => { e.preventDefault(); onMouseDown(); }}
        onTouchStart={(e) => { e.preventDefault(); onTouchStart(); }}
        sx={{
          position: 'absolute',
          left: `${String(x)}%`,
          top: `${String(y)}%`,
          transform: 'translate(-50%, -50%)',
          width: 40,
          height: 40,
          borderRadius: '50%',
          bgcolor: bgColor,
          color: 'common.white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: isDragging ? 'grabbing' : 'grab',
          boxShadow: isDragging ? 6 : 2,
          zIndex: isDragging ? 100 : 1,
          transition: isDragging ? 'none' : 'box-shadow 0.2s',
          '&:hover': {
            boxShadow: 4,
          },
          touchAction: 'none',
        }}
      >
        <Typography variant="caption" fontWeight={700} sx={{ fontSize: '0.65rem', lineHeight: 1 }}>
          {lift.identifier}
        </Typography>
      </Box>
    </Tooltip>
  );
}
